import type { CareerEntry } from '../types/profile'

export const careerEntries: CareerEntry[] = [
  {
    period: 'Most Recent',
    title: 'Director, Advanced Manufacturing',
    organisation: 'Department for Business & Trade',
    summary:
      'Directed United Kingdom industrial strategy across twenty manufacturing sectors and acted as the senior government relationship lead to the nation’s largest industrial employers.',
    achievements: [
      'Senior government lead for BAE Systems, Tata Group, Siemens and Make UK.',
      'Co-established the UK Green Investment Bank, the Aerospace Technology Institute and the Advanced Propulsion Centre.',
      'Negotiated long-term sector deals and co-investment frameworks between government and industry.',
      'Built the departmental capability to hold sustained relationships with global manufacturers.',
    ],
  },
  {
    period: 'Preceding',
    title: 'Director, Business Support Simplification',
    organisation: 'Department for Business & Trade',
    summary:
      'Led the most significant rationalisation of United Kingdom government business support in a generation.',
    achievements: [
      'Reduced more than 1,000 overlapping government products to 30 streamlined offerings.',
      'Redesigned delivery around business need rather than departmental structure.',
      'Introduced evaluation discipline for public value and measurable outcomes.',
      'Secured cross-departmental agreement for a single front door for business.',
    ],
  },
  {
    period: 'Earlier',
    title: 'Director, Employment Law',
    organisation: 'Department for Business & Trade',
    summary:
      'Owned the policy and legislative programme governing the relationship between employers and the workforce.',
    achievements: [
      'Spearheaded landmark family-friendly workforce legislation.',
      'Balanced employer competitiveness against employee protection through tripartite negotiation.',
      'Represented the department in parliamentary scrutiny of primary legislation.',
      'Established consultation practice with employer bodies and trade unions.',
    ],
  },
]
